<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Dipendenti</h4>
                </div>
                <div class="col-md-6">
                  <fg-input type="text"
                          label=""
                          placeholder="Cerca..."
                          v-model="pattern">
                  </fg-input>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12 table-responsive">
                <l-table class="table-hover table-striped"
                         :columns="dipendentiColumns"
                         :data="dipendenti"
                         :url="url"
                         :pattern="pattern"
                         :getRowClass="dipendentiRowClass"
                         @onClick="onClick">
                </l-table>
              </div>
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-info btn-fill" @click.prevent="newDipendente">
                  Nuovo Dipendente
                </button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        url: process.env.API_URL + 'dipendente?withTrashed=true',
        dipendentiColumns: [
          {
            key: 'nome',
            text: 'Nome'
          },
          {
            key: 'cognome',
            text: 'Cognome'
          },
          {
            key: 'paga_oraria',
            text: 'Paga oraria',
            renderer: function (record) {
              var str = this.numberToString(record.paga_oraria)
              if (str !== '') {
                str += ' €/h'
              }
              return str
            },
            getCellClass: function (item) {
              return 'dashboard-align-right'
            },
            getHeaderClass: function () {
              return 'dashboard-align-right'
            }
          }
        ],
        dipendentiRowClass: function (data) {
          return data.deleted_at ? 'text-danger' : ''
        },
        dipendenti: [],
        pattern: this.$route.params.pattern
      }
    },
    methods: {
      onClick: function (data) {
        this.$root.$router.push('/dashboard/dipendente/' + data.id)
      },
      newDipendente: function () {
        this.$root.$router.push('/dashboard/dipendente-new')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DipendenteList.vue